import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk, RootState } from "./store";
import { getOrgId } from "./orgHelpers";
import { UserService } from "../services/UserService";
import { DepositsService } from "../services/DepositService";
import { TransactionService } from "../services/TransactionService";
import { DepositType } from "../models/Depoist";
import { AddDepositInfo } from "../components/admin-modal-deposit";
import { openToast } from "./ToastSlice";

interface TransactionState {
  depositsList: Array<any>;
  modalStatus: boolean;
  transactionsList: Array<any>,
  walletHistory : Array<any>,
  loadingWalletHistory: boolean,
  withdrawalStatus : boolean,
  withdrawalCreationStatus: boolean,
  addDepositLoading: boolean
}

const initialState: TransactionState = {
  depositsList: [],
  modalStatus: false,
  transactionsList: [],
  walletHistory : [],
  loadingWalletHistory: false,
  withdrawalStatus : false,
  withdrawalCreationStatus: false,
  addDepositLoading: false
};

const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    setDepositsList(state, action: PayloadAction<Array<any>>) {
      state.depositsList = action.payload;
    },
    setModalDepositStatus(state, action: PayloadAction<boolean>) {
      state.modalStatus = action.payload;
    },
    setTransactionsList(state, action: PayloadAction<Array<any>>) {
      state.transactionsList = action.payload;
    },
    setWalletHistory: (state, action: PayloadAction<Array<any>>) => {
      state.walletHistory = action.payload;
    },
    setWalletHistoryLoading: (state, action: PayloadAction<boolean>) => {
      state.loadingWalletHistory = action.payload;
    },
    setWithdrawalStatus: (state, action: PayloadAction<boolean>) => {
      state.withdrawalStatus = action.payload
    },
    setCreateWithdrawalStatus: (state, action: PayloadAction<boolean>) => {
      state.withdrawalCreationStatus = action.payload
    },
    setAddDepositLoading: (state, action: PayloadAction<boolean>) => {
      state.addDepositLoading = action.payload
    },

  }
});

export const {
  setDepositsList,
  setModalDepositStatus,
  setTransactionsList,
  setWalletHistory,
  setWalletHistoryLoading,
  setWithdrawalStatus,
  setCreateWithdrawalStatus,
  setAddDepositLoading
} = transactionSlice.actions;

// customs func
export const getDeposistList = (state: RootState): Array<any> => state.transaction.depositsList;
export const getModalDepositStatus = (state: RootState): boolean => state.transaction.modalStatus;
export const getTransactionsList = (state: RootState): Array<any> => state.transaction.transactionsList;

// Deposit
export const fetchDepositsList = (id:number) : AppThunk<Promise<void>> => async (dispatch) => {
    const depositResponse : any = await DepositsService.getAllDepositsByOrganization(id);
    
    if (!depositResponse) throw new Error('Erro ao tentar pegar usuarios')

    dispatch(setDepositsList(depositResponse));
    dispatch(setModalDepositStatus(false))
}

export const addDeposit = (payload:AddDepositInfo) : AppThunk<Promise<void>> => async (dispatch, getState) => {

    dispatch(setAddDepositLoading(true))
    try {
      const id = getOrgId(getState());
  
      if (!payload) throw new Error('Erro ao tentar adicionar deposito - faltando dados')

      // Envia só os campos do DTO do backend (evita 400 do forbidNonWhitelisted:
      // accountId/userId/network/password nao existem no CreateDepositPayload).
      const clean: any = {
        target_user_id: Number(payload.target_user_id),
        value:          Number(payload.value),
        bankId:         Number(payload.bankId),
        assetId:        Number(payload.assetId),
        organizationId: id,
        name:           payload.name,
        document:       payload.document,
        login:          payload.login,
        email:          payload.email,
      };
      if (payload.depositor) clean.depositor = Number(payload.depositor);
      if (payload.type)      clean.type = payload.type;
      if (payload.hash)      clean.hash = payload.hash;
      

      const depositResponse : any = await DepositsService.createDeposits(clean);
      if (!depositResponse) throw new Error('Erro ao tentar adicionar usuarios')
  
      // A lista e recarregada ao fechar o modal (ver AdminModalDepost),
      // para nao disparar dois GETs identicos no mesmo fluxo.
      dispatch(openToast({
        title: "Depósito adicionado",
        message: "O depósito foi criado com sucesso.",
        effect: "success",
      }));
    } catch (e) {
      console.error(e)
      dispatch(openToast({
        title: "Erro ao adicionar depósito",
        message: "Não foi possível concluir o depósito. Tente novamente.",
        effect: "error",
      }));
    } finally {
      dispatch(setAddDepositLoading(false))
    }
}

export const fetchLastestTransactions = (page: number = 1) : AppThunk<Promise<void>> => async (dispatch) => {

    const transactionsList : any = await TransactionService.getLatestTransactions(page);
    if (!transactionsList) throw new Error('Erro ao tentar adicionar usuarios')

    dispatch(setTransactionsList(transactionsList));
}
//getByDate
export const fetchAmountByDate = (sd:string,ed:string,status:string) : AppThunk<Promise<void>> => async (dispatch) => {
    
    const transactionsList : any = await TransactionService.getAmountByDates(sd,ed,status);
    if (!transactionsList) throw new Error('Erro ao tentar adicionar usuarios')

    dispatch(setTransactionsList(transactionsList));
}

export const fetchHistoryByWallet = (id:number) : AppThunk<Promise<void>> => async (dispatch) => {
    dispatch(setWalletHistoryLoading(true));
    try {
        const walletHistory : any = await TransactionService.getHistopryByWallet(id);
        if (!walletHistory) throw new Error('impossivel pegart historico')
        dispatch(setWalletHistory(walletHistory.data))
        dispatch(setWalletHistoryLoading(false));
    } catch (e) {
        console.error(e);
        dispatch(setWalletHistoryLoading(false));
    }
}

export default transactionSlice.reducer;